import * as Actions from '../actions';

const initialState = {
	items: [],
	selected: null,
	loading: false,
	error: null,
	formOpen: false
};

const sharedStorageReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SHARED_STORAGE_LOADING:
			return { ...state, loading: true, error: null };
		case Actions.SHARED_STORAGE_SUCCESS:
			return { ...state, loading: false, items: action.payload || [] };
		case Actions.SHARED_STORAGE_ERROR:
			return { ...state, loading: false, error: action.payload };
		case Actions.SHARED_STORAGE_SELECT:
			return { ...state, selected: action.payload };
		case Actions.SHARED_STORAGE_CREATE_SUCCESS:
			return { ...state, items: [action.payload, ...state.items], formOpen: false };
		case Actions.SHARED_STORAGE_DELETE_SUCCESS:
			return {
				...state,
				items: state.items.filter((x) => (x._id || x.id) !== action.payload)
			};
		case Actions.SHARED_STORAGE_FORM_OPEN:
			return { ...state, formOpen: true };
		case Actions.SHARED_STORAGE_FORM_CLOSE:
			return { ...state, formOpen: false };
		default:
			return state;
	}
};

export default sharedStorageReducer;
